import { Outlet } from 'react-router-dom';
const Marketplace = () => {
  return (
    <div className='container pt-12'>
      <Outlet />
    </div>
  );
};
export default Marketplace;
